import { render, staticRenderFns } from "./HomeSlides.vue?vue&type=template&id=6aafc4fe&scoped=true&"
import script from "./HomeSlides.vue?vue&type=script&lang=js&"
export * from "./HomeSlides.vue?vue&type=script&lang=js&"
import style0 from "./HomeSlides.vue?vue&type=style&index=0&id=6aafc4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aafc4fe",
  null
  
)

export default component.exports